"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrillTargetUrlItem = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2023 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var types_1 = require("../../../../drill/types");
var CustomUrlSection_1 = require("../../../../drill/DrillConfigPanel/DrillToUrl/CustomUrlSection");
var CustomUrlEditor_1 = require("../../../../drill/DrillConfigPanel/DrillToUrl/CustomUrlEditor");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var AttributeUrlSection_1 = require("../../../../drill/DrillConfigPanel/DrillToUrl/AttributeUrlSection");
var model_1 = require("../../../../../model");
var useInvalidAttributeDisplayFormIdentifier_1 = require("./useInvalidAttributeDisplayFormIdentifier");
var useAttributesWithDisplayForms_1 = require("./useAttributesWithDisplayForms");
function useButtonValue(urlDrillTarget) {
    var intl = react_intl_1.useIntl();
    var displayForms = model_1.useDashboardSelector(model_1.selectAllCatalogDisplayFormsMap);
    var attributes = model_1.useDashboardSelector(model_1.selectAllCatalogAttributesMap);
    if (types_1.isDrillToCustomUrlConfig(urlDrillTarget) && urlDrillTarget.customUrl) {
        return urlDrillTarget.customUrl;
    }
    if (types_1.isDrillToAttributeUrlConfig(urlDrillTarget) && urlDrillTarget.drillToAttributeDisplayForm) {
        var displayForm = displayForms.get(urlDrillTarget.drillToAttributeDisplayForm);
        ts_invariant_1.default(displayForm, "inconsistent state in drill to URL button");
        var attribute = attributes.get(displayForm.attribute);
        ts_invariant_1.default(attribute, "inconsistent state in drill to URL button");
        return attribute.attribute.title + " (" + displayForm.title + ")";
    }
    return intl.formatMessage({ id: "configurationPanel.drillIntoUrl.defaultButtonValue" });
}
var dropdownAlignPoints = [{ align: "bl tl" }, { align: "tl bl" }];
exports.DrillTargetUrlItem = function (props) {
    var onSelect = props.onSelect, urlDrillTarget = props.urlDrillTarget, attributes = props.attributes;
    var capabilities = model_1.useDashboardSelector(model_1.selectBackendCapabilities);
    var settings = model_1.useDashboardSelector(model_1.selectSettings);
    var _a = useAttributesWithDisplayForms_1.useAttributesWithDisplayForms(attributes), targetAttributesFormsAll = _a.allDisplayForms, targetAttributesFormsWithLinks = _a.linkDisplayForms;
    var invalidAttributeDisplayFormIdentifiers = useInvalidAttributeDisplayFormIdentifier_1.useInvalidAttributeDisplayFormIdentifiers(urlDrillTarget, attributes);
    var _b = tslib_1.__read(react_1.useState(false), 2), showModal = _b[0], setShowModal = _b[1];
    var toggleModal = function () { return setShowModal(!showModal); };
    var onCustomUrlHandler = function (customUrl) {
        setShowModal(false);
        onSelect({ customUrl: customUrl });
    };
    var onAttributeUrlHandler = function (insightAttributeDisplayForm, drillToAttributeDisplayForm) {
        onSelect({
            insightAttributeDisplayForm: insightAttributeDisplayForm,
            drillToAttributeDisplayForm: drillToAttributeDisplayForm,
        });
    };
    var _c = sdk_ui_1.useClientWorkspaceIdentifiers(), client = _c.client, dataProduct = _c.dataProduct;
    var buttonValue = useButtonValue(urlDrillTarget);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(sdk_ui_kit_1.Dropdown, { closeOnParentScroll: true, alignPoints: dropdownAlignPoints, renderButton: function (_a) {
                var toggleDropdown = _a.toggleDropdown, isOpen = _a.isOpen;
                return (react_1.default.createElement(sdk_ui_kit_1.Button, { onClick: toggleDropdown, className: "gd-button gd-button-primary button-dropdown dropdown-button gd-button-small s-drill-to-url-button", iconRight: isOpen ? "gd-icon-navigateup" : "gd-icon-navigatedown", value: buttonValue }));
            }, renderBody: function (_a) {
                var closeDropdown = _a.closeDropdown;
                return (react_1.default.createElement("div", { className: "gd-menu-wrapper gd-drill-to-url-body gd-drill-to-url-list s-gd-drill-to-url-body" },
                    capabilities.supportsHyperlinkAttributeLabels ? (react_1.default.createElement(AttributeUrlSection_1.AttributeUrlSection, { attributeDisplayForms: targetAttributesFormsWithLinks, onSelect: function (insightAttributeDisplayForm, drillToAttributeDisplayForm) {
                            onAttributeUrlHandler(insightAttributeDisplayForm, drillToAttributeDisplayForm);
                            closeDropdown();
                        }, selected: types_1.isDrillToAttributeUrlConfig(urlDrillTarget) &&
                            urlDrillTarget.drillToAttributeDisplayForm })) : null,
                    react_1.default.createElement(CustomUrlSection_1.CustomUrlSection, tslib_1.__assign({}, props, { urlDrillTarget: urlDrillTarget, toggleModal: toggleModal, closeDropdown: closeDropdown })),
                    showModal ? (react_1.default.createElement(CustomUrlEditor_1.CustomUrlEditor, { urlDrillTarget: urlDrillTarget, attributeDisplayForms: targetAttributesFormsAll, invalidAttributeDisplayFormIdentifiers: invalidAttributeDisplayFormIdentifiers, documentationLink: String(settings.drillIntoUrlDocumentationLink || ""), enableClientIdParameter: !!client, enableDataProductIdParameter: !!dataProduct, enableWidgetIdParameter: !!capabilities.supportsWidgetEntity, onSelect: function (customUrl) {
                            onCustomUrlHandler(customUrl);
                            closeDropdown();
                        }, onClose: toggleModal })) : null));
            } })));
};
//# sourceMappingURL=DrillTargetUrlItem.js.map